import React from "react";
import { Card } from "@shopify/polaris";
interface Props {
  message?: string;
}

const NoDataFound: React.FunctionComponent<Props> = ({
  message = "No data available",
}) => {
  return (
    <Card>
      <div style={{ padding: "6rem" }}>
        <img
          src={
            "https://sr-track-plus-global-track-web-qa-1.kartrocket.com/assets/images/no_data.svg"
          }
          style={{ display: "block", margin: "0 auto" }}
          alt=""
        />
        <p  className="noDataHeader text-center">{message}</p>
        
      </div>
    </Card>
  );
};

export default NoDataFound;
